import React from 'react';
import { motion } from 'framer-motion';
import { FaTruck, FaShuttleVan, FaTruckMoving } from 'react-icons/fa';

const Fleet = () => {
  const vehicles = [
    {
      id: 1,
      name: 'Break',
      icon: <FaShuttleVan />,
      capacity: '500 kg',
      dimensions: '1 palette 80×120×110 cm',
      description: 'Idéal pour les petites livraisons et colis urgents'
    },
    {
      id: 2,
      name: 'Fourgon',
      icon: <FaTruck />,
      capacity: '1500 kg',
      dimensions: '4 palettes 80×120×170 cm',
      description: 'Parfait pour les livraisons moyennes et déménagements'
    },
    {
      id: 3,
      name: '20m³ (Hayon/Débâchable)',
      icon: <FaTruckMoving />,
      capacity: '800 kg',
      dimensions: '8 palettes 80×120×200 cm',
      description: 'Pour les gros volumes et marchandises volumineuses'
    }
  ];

  return (
    <section id="fleet" className="fleet">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Notre Flotte</h2>
          <p>Des véhicules adaptés à tous vos besoins de transport</p>
        </motion.div>
        
        <div className="fleet-grid">
          {vehicles.map((vehicle, index) => (
            <motion.div
              key={vehicle.id}
              className="fleet-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="fleet-icon">
                {vehicle.icon}
              </div>
              <h3>{vehicle.name}</h3>
              <div className="fleet-specs">
                <div className="spec-item">
                  <span className="spec-label">Charge utile</span>
                  <span className="spec-value">{vehicle.capacity}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Dimensions</span>
                  <span className="spec-value">{vehicle.dimensions}</span>
                </div>
              </div>
              <p className="fleet-description">{vehicle.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Fleet;
